module.exports = __webpack_public_path__ + "img/file-waveform.2d658bc6.svg";